import React from 'react';
import { Modal, Button, Form } from 'semantic-ui-react';
import axios from "axios";
import Zello from './Zello';
import Recaptcha from 'react-recaptcha';

class Login extends React.Component {
  state = {
    nameValue: '',
    passwordValue: '',
    captchaResponse: '',
    requireCaptcha: Zello.verifyLogin
  };

  handleClose = () => {
    this.props.history.push("/");
    this.props.onCancel();
  };

  handleSubmit = () => {
    console.log("Logging in as " + this.state.nameValue);
    const params = new URLSearchParams();
    params.append('username', this.state.nameValue);
    params.append('password', this.state.passwordValue);
    params.append('captcha', this.state.captchaResponse);
    axios.request({
      url: Zello.getApiUrl('/auth'),
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true,
      data: params
    })
    .then((response) => {
      Zello.setProfile(response.data);
      this.props.onSuccess(this.state.nameValue);
      this.attempts = 0;
    })
    .catch((e) => {
      let message = 'Unable to log in at this time';
      if (e && e.response && e.response.status === 401) {
        message = 'Invalid username or password';
      }

      this.setState({
        error: true,
        errorMessage: message,
        requireCaptcha: e.response.data && e.response.data.captcha
      });
    });
  };

  onNameChange = (e) => {
    this.setState({
      nameValue: e.target.value,
      error: false,
      errorMessage: ''
    });
  };

  onPasswordChange = (e) => {
    this.setState({
      passwordValue: e.target.value
    });
  };

  onCaptchaVerify = (response) => {
    this.setState({
      captchaResponse: response
    });
  };

  onKeyUp = (e) => {
    if (e.key === 'Enter') {
      this.handleSubmit();
    }
  };

  render() {
    return (
      <div>
        <Modal
          open={true}
          closeOnDimmerClick={false}
          onKeyUp={this.onKeyUp}
        >
          <Modal.Header>
            Log In
          </Modal.Header>
          <Modal.Content>
            <Form>
              <Form.Field>
                <label>Username</label>
                <Form.Input placeholder='Username' error={this.state.error} onChange={this.onNameChange} />
                {this.state.error && <span>{this.state.errorMessage}</span>}
              </Form.Field>
              <Form.Field>
                <label>Password</label>
                <input type="password" placeholder="Password" onChange={this.onPasswordChange} />
              </Form.Field>
              {this.state.requireCaptcha && <Recaptcha
                render="explicit"
                sitekey="6LdWTGQrAAAAAPN--RE6v943tgKYbzdLZ-zX4t4R"
                verifyCallback={this.onCaptchaVerify}
              />}
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <span>Don't have an account yet?  <a href="https://zello.com/user/home" title="Create Account">Create one!</a></span>
            <Button onClick={this.handleClose}>
              Close
            </Button>
            <Button primary onClick={this.handleSubmit}>
              Submit
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js